var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header pl-0" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-menu-wrapper navbar navbar-expand-lg" },
            [
              _c("ul", { staticClass: "navbar-nav" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "span",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.activeComponent == "main" },
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("\n              Main\n            ")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        { staticClass: "inspector-wrapper" },
        [
          [
            _c("div", { staticClass: "row" }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-9" },
                [
                  _vm.activeComponent == "main" ? _c("maininspector") : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-3" }, [
                _vm.selectedEffect
                  ? _c("h4", [_vm._v(_vm._s(_vm.selectedEffect.name))])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "selected-char-imgwrap mr-4" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    staticStyle: { width: "100%" },
                    attrs: {
                      src:
                        _vm.selectedEffect.objectDbHash &&
                        _vm.effects[_vm.selectedEffect.objectDbHash].image
                          .imageURL
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-3" }, [
      _c("img", {
        staticClass: "heading-icon mr-2",
        attrs: { src: require("@/assets/device_hub_icon.svg") }
      }),
      _vm._v(" Inspector")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4 d-none" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("button", { staticClass: "btn btn-outline-primary mr-3" }, [
          _vm._v("Save")
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "btn btn-outline-secondary" }, [
          _vm._v("Cancel")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be149ffc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be149ffc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-wrap/effectsInspector.vue
// module id = null
// module chunks = 